import { useContext } from "react";
import { WhitelistContext } from "context/WhitelistContext";

export default function useWhitelistContext() {
  return useContext(WhitelistContext);
}
